(() => {
  const configElement = document.getElementById('MozefLanguageConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch {
    return;
  }
  const languages = config.languages;
  if (!Array.isArray(languages) || languages.length < 2) return;

  const preferenceKey = 'mozef.language-choice';
  const normalize = (code) => String(code || '').toLowerCase();
  const exactMatch = (code) => languages.find((language) => normalize(language.code) === normalize(code));
  const remember = (code) => {
    const language = exactMatch(code);
    if (!language) return;
    try {
      localStorage.setItem(preferenceKey, language.code);
    } catch {
      // The Shopify form still works when browser storage is unavailable.
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form.mz-localization, form.localization-form')) return;
    remember(form.querySelector('[name="language_code"]')?.value);
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mz-language-links a[hreflang]');
    if (link) remember(link.getAttribute('hreflang'));
  });

  // A locale URL is an explicit destination; only the default entry point redirects.
  const currentUrl = new URL(window.location.href);
  const pathname = currentUrl.pathname.replace(/\/+$/, '') || '/';
  const isHomepage = config.pageType === 'index' && pathname === '/';
  const isLaunchPage = config.pageType === 'password' && pathname === '/password';
  if (!isHomepage && !isLaunchPage) return;

  let preferred;
  try {
    preferred = exactMatch(localStorage.getItem(preferenceKey));
  } catch {
    // Browser language remains available without persistent storage.
  }
  if (!preferred) {
    for (const code of navigator.languages?.length ? navigator.languages : [navigator.language]) {
      preferred = exactMatch(code) || languages.find((language) =>
        normalize(language.code).split('-')[0] === normalize(code).split('-')[0]
      );
      if (preferred) break;
    }
  }
  if (!preferred) return;

  const root = preferred.root.replace(/\/+$/, '');
  const destination = (root || '') + (isLaunchPage ? '/password' : '') || '/';
  if (destination === pathname || !destination.startsWith('/') || destination.startsWith('//')) return;
  currentUrl.pathname = destination;
  window.location.replace(currentUrl.href);
})();
